import { QueryKeys } from '../../../enums/queryKeys'
import { TransactionsQueryProps } from '../types/transactionsQueryProps'

export const getTransactionsQueryKey = (queryProps: TransactionsQueryProps): [QueryKeys, TransactionsQueryProps] => [
  QueryKeys.Transactions,
  queryProps,
]
